import ComingSoon from "../components/comingSoon";
import { FaRegCircle } from "react-icons/fa";
import { MdArticle } from "react-icons/md";
import AddArticle from "views/ArticleManagement/AddArticle";
import ArticleDetails from "views/ArticleManagement/ArticleDetails";
import ArticleList from "views/ArticleManagement/ArticleList";
import UpdateArticle from "views/ArticleManagement/UpdateArticle";

const ArticleRoutes = [
  {
    path: "/article/details",
    name: "Article Details",
    icon: "nc-icon nc-bank",
    component: <ArticleDetails />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    path: "/article/update",
    name: "Update Article",
    icon: "nc-icon nc-bank",
    component: <UpdateArticle />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    name: "Article Management",
    icon: <MdArticle />,
    iconDown: "nc-icon nc-minimal-down",
    layout: "/admin",
    showInSidebar: true,
    subNav: [
      {
        path: "/article/list",
        title: "Article List",
        icon: <FaRegCircle />,
        component: <ArticleList/>,
        layout: "/admin",
        name: "sub-nav",
        showInSidebar: true,
      },
      {
        path: "/article/add",
        title: "Add Article",
        icon: <FaRegCircle />,
        component: <AddArticle />,
        layout: "/admin",
        name: "sub-nav",
        showInSidebar: true,
      }
    ],
  }
];


export default ArticleRoutes;